import { SchedulerV3 } from '@frontend/api-schedule-v3';

export const useGetLocationSettings = (locationIds: string[]) => {
  const locationSettings = SchedulerV3.Queries.useListLocationSettingsQuery({
    request: { locationIds },
    options: {
      enabled: !!locationIds.length,
    },
  });

  return {
    data: locationSettings.data?.locationsSettings,
    isLoading: locationSettings.isLoading,
    isError: locationSettings.isError,
    refetch: locationSettings.refetch,
  };
};
